/**
 * Defines the list of Category Hub patterns.
 * Each pattern associates a Provider with a path-test,
 * resulting in a hub pathname.
 */
import Provider from '@/enums/Provider';
import { ICategoryHubPattern } from '@/interfaces/ICategoryHubPattern';

/**
 * All available patterns used to generate category-hub URLs.
 */
export const patterns: ICategoryHubPattern[] = [
    { provider: Provider.IO, test: p => p.startsWith('/rentals/'), hubPathname: '/rentals/' },
    { provider: Provider.IO, test: p => p.startsWith('/inventory/'), hubPathname: '/inventory/' },
    { provider: Provider.ERS, test: p => p.startsWith('/products/'), hubPathname: '/category/' },
    // …add more patterns as needed
];